import { render, staticRenderFns } from "./InterForm.vue?vue&type=template&id=39487a04&scoped=true&"
import script from "./InterForm.vue?vue&type=script&lang=js&"
export * from "./InterForm.vue?vue&type=script&lang=js&"
import style0 from "./InterForm.vue?vue&type=style&index=0&id=39487a04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39487a04",
  null
  
)

export default component.exports